import { Component, OnInit } from '@angular/core';
import { ConfigService } from '~app/services';

@Component({
    selector: 'app-fs-footer',
    templateUrl: './fs-footer.component.html',
    styleUrls: ['./fs-footer.component.less'],
    standalone: false
})
export class FsFooterComponent implements OnInit {
  links = [
    {
      text: 'FS.USDA.gov',
      route: 'https://www.fs.usda.gov',
    },
    {
      text: 'USDA.gov',
      route: 'https://www.usda.gov',
    },
    {
      text: 'Whitehouse.gov',
      route: 'https://www.whitehouse.gov',
    },
    {
      text: 'FOIA.gov',
      route:
        'https://www.usda.gov/ogc/office-information-affairs/foia-division',
    },
    {
      text: 'Plain Writing',
      route: 'https://www.usda.gov/plain-writing',
    },
    {
      text: 'Policies & Links',
      route: 'https://www.usda.gov/policies-and-links',
    },
  ];

  socialLinks = [
    {
      name: 'X',
      icon: '/assets/img/icons/x.svg',
      route: 'https://x.com/forestservice',
    },
    {
      name: 'Facebook',
      icon: '/assets/img/icons/facebook.svg',
      route: 'https://www.facebook.com/USForestService',
    },
    {
      name: 'LinkedIn',
      icon: '/assets/img/icons/linkedin.svg',
      route: 'https://www.linkedin.com/company/usda-forest-service',
    },
    {
      name: 'YouTube',
      icon: '/assets/img/icons/youtube.svg',
      route: 'https://www.youtube.com/user/usdaForestService',
    },
    {
      name: 'Flickr',
      icon: '/assets/img/icons/flickr.svg',
      route: 'https://www.flickr.com/photos/forestservice',
    },
    {
      name: 'Instagram',
      icon: '/assets/img/icons/instagram.svg',
      route: 'https://www.instagram.com/usforestservice',
    },
  ];

  versionInfoString = [
    'CIAO Version',
    this.configService.getConfig('version_number'),
  ].join(' ');

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    // When the user scrolls down 20px from the top of the document, show the white bar
    window.onscroll = () => {
      this.scrollFunc();
    };
  }

  // Hide and show the white bar
  scrollFunc() {
    let returnToTopBar = document.getElementById('scrollBar');

    if (
      document.body.scrollTop > 40 ||
      document.documentElement.scrollTop > 40
    ) {
      returnToTopBar.style.display = 'block';
    } else {
      returnToTopBar.style.display = 'none';
    }
  }

  // Scroll to top of page
  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  clickLink = (link) => {
    window.location.href = link.route;
  };
}
